import React, { useState, useEffect } from 'react';
import { Spin, Form } from 'antd';

import './surveyScreenThanks.css';
import '../newMain/newMain.css';


const SurveyScreenThanks = (props) => {

    const [isLoad, setIsLoad] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
    }, []);

    return (
        <div id="container" className='websiteTemplate surveyScreenThanks'>
            <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className='detailTitle'></div>
                    </div>
                </div>
                <div className='websiteSysContentBox'>
                    <Form form={form}>
                        <div className='marginBotAndtop'>
                            <div className='contentTitle'>
                                谢谢完成本评估表格。
                            </div>
                            <div className='contentTitle'>
                                謝謝完成本評估表格。
                            </div>
                            <div className='contentTitle'>
                                Thank you for completing this evaluation form.
                            </div>
                        </div>
                    </Form>
                </div>
            </Spin>
        </div>
    )

}

export default SurveyScreenThanks;